/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

!function(i){function t(t){var e=0;return t.children("li").each(function(){e+=i(this).outerWidth(!0)}),e}function e(t){return Math.max.apply(Math,t.children().map(function(){return i(this).width()}).get())}function s(i){var t=i.data("settings")||{direction:"left",speed:50},e=i.children().first(),s=Math.abs(-i.css(t.direction).replace("px","").replace("auto","0")-e.outerWidth(!0)),n=1e3*s/t.speed,r={};return r[t.direction]=i.css(t.direction).replace("px","").replace("auto","0")-s,{css:r,time:n}}function n(i){var t=i.data("settings")||{direction:"left"};i.css("transition-duration","0s").css(t.direction,"0");var e=i.children().first();e.hasClass("webticker-init")?e.remove():i.children().last().after(e)}function r(i,t){var e=i.data("settings")||{direction:"left"};"undefined"==typeof t&&(t=!1),t&&n(i);var a=s(i);i.animate(a.css,a.time,"linear",function(){i.css(e.direction,"0"),r(i,!0)})}function a(i,t){"undefined"==typeof t&&(t=!1),t&&n(i);var e=s(i),r=e.time/1e3;r+="s",i.css(e.css).css("transition-duration",r)}function c(t,e,s){var n=[];i.get(t,function(t){var r=i(t);r.find("item").each(function(){var t=i(this),e={title:t.find("title").text(),link:t.find("link").text()},s='<li><a href="'+e.link+'"">'+e.title+"</a></li>";n+=s}),s.webTicker("update",n,e)})}function l(s,n){if(s.children("li").length<1)return window.console,!1;var r=s.data("settings");r.duplicateLoops=r.duplicateLoops||0,s.width("auto");var a=0;s.children("li").each(function(){a+=i(this).outerWidth(!0)});var c,l=s.find("li:first").height();if(r.duplicate){c=e(s);for(var o=0;a-c<s.parent().width()||1===s.children().length||o<r.duplicateLoops;){var d=s.children().clone();s.append(d),a=0,a=t(s),c=e(s),o++}r.duplicateLoops=o}else{var h=s.parent().width()-a;h+=s.find("li:first").width(),s.find(".ticker-spacer").length>0?s.find(".ticker-spacer").width(h):s.append('<li class="ticker-spacer" style="float: '+r.direction+";width:"+h+"px;height:"+l+'px;"></li>')}r.startEmpty&&n&&s.prepend('<li class="webticker-init" style="float: '+r.direction+";width:"+s.parent().width()+"px;height:"+l+'px;"></li>'),a=0,a=t(s),s.width(a+200);var f=0;for(f=t(s);f>=s.width();)s.width(s.width()+200),f=0,f=t(s);return!0}var o=function(){var i=document.createElement("p").style,t=["ms","O","Moz","Webkit"];if(""===i.transition)return!0;for(;t.length;)if(t.pop()+"Transition"in i)return!0;return!1}(),d={init:function(t){return t=jQuery.extend({speed:50,direction:"left",moving:!0,startEmpty:!0,duplicate:!1,rssurl:!1,hoverpause:!0,rssfrequency:0,updatetype:"reset",transition:"linear",height:"30px",maskleft:"",maskright:"",maskwidth:0},t),this.each(function(){jQuery(this).data("settings",t);var e=jQuery(this),s=e.wrap('<div class="mask"></div>');s.after('<span class="tickeroverlay-left">&nbsp;</span><span class="tickeroverlay-right">&nbsp;</span>');var n,d=e.parent().wrap('<div class="tickercontainer"></div>');if(i(window).resize(function(){clearTimeout(n),n=setTimeout(function(){console.log("window was resized"),l(e,!1)},500)}),e.children("li").css("white-space","nowrap"),e.children("li").css("float",t.direction),e.children("li").css("padding","0 7px"),e.children("li").css("line-height",t.height),s.css("position","relative"),s.css("overflow","hidden"),e.closest(".tickercontainer").css("height",t.height),e.closest(".tickercontainer").css("overflow","hidden"),e.css("float",t.direction),e.css("position","relative"),e.css("font","bold 10px Verdana"),e.css("list-style-type","none"),e.css("margin","0"),e.css("padding","0"),""!==t.maskleft&&""!==t.maskright){var h='url("'+t.maskleft+'")';d.find(".tickeroverlay-left").css("background-image",h),d.find(".tickeroverlay-left").css("display","block"),d.find(".tickeroverlay-left").css("pointer-events","none"),d.find(".tickeroverlay-left").css("position","absolute"),d.find(".tickeroverlay-left").css("z-index","30"),d.find(".tickeroverlay-left").css("height",t.height),d.find(".tickeroverlay-left").css("width",t.maskwidth),d.find(".tickeroverlay-left").css("top","0"),d.find(".tickeroverlay-left").css("left","-2px"),h='url("'+t.maskright+'")',d.find(".tickeroverlay-right").css("background-image",h),d.find(".tickeroverlay-right").css("display","block"),d.find(".tickeroverlay-right").css("pointer-events","none"),d.find(".tickeroverlay-right").css("position","absolute"),d.find(".tickeroverlay-right").css("z-index","30"),d.find(".tickeroverlay-right").css("height",t.height),d.find(".tickeroverlay-right").css("width",t.maskwidth),d.find(".tickeroverlay-right").css("top","0"),d.find(".tickeroverlay-right").css("right","-2px")}else d.find(".tickeroverlay-left").css("display","none"),d.find(".tickeroverlay-right").css("display","none");e.children("li").last().addClass("last");var f=l(e,!0);t.rssurl&&(c(t.rssurl,t.type,e),t.rssfrequency>0&&window.setInterval(function(){c(t.rssurl,t.type,e)},1e3*t.rssfrequency*60)),o?(e.css("transition-timing-function",t.transition),e.css("transition-duration","0s").css(t.direction,"0"),f&&a(e,!1),e.on("transitionend webkitTransitionEnd oTransitionEnd otransitionend",function(t){return!!e.is(t.target)&&void a(i(this),!0)})):f&&r(i(this)),t.hoverpause&&e.hover(function(){if(o){var e=i(this).css(t.direction);i(this).css("transition-duration","0s").css(t.direction,e)}else jQuery(this).stop()},function(){jQuery(this).data("settings").moving&&(o?a(i(this),!1):r(e))})})},stop:function(){var t=i(this).data("settings");if(t.moving)return t.moving=!1,this.each(function(){if(o){var e=i(this).css(t.direction);i(this).css("transition-duration","0s").css(t.direction,e)}else i(this).stop()})},cont:function(){var t=i(this).data("settings");if(!t.moving)return t.moving=!0,this.each(function(){o?a(i(this),!1):r(i(this))})},transition:function(t){var e=i(this);o&&e.css("transition-timing-function",t)},update:function(e,s,n,r){s=s||"reset","undefined"==typeof n&&(n=!0),"undefined"==typeof r&&(r=!1),"string"==typeof e&&(e=i(e));var a=i(this);a.webTicker("stop");var c=i(this).data("settings");if("reset"===s)a.html(e),l(a,!0);else if("swap"===s){var o,d,h,f;if(window.console,a.children("li").length<1)a.html(e),a.css(c.direction,"0"),l(a,!0);else if(c.duplicate===!0){a.children("li").addClass("old");for(var p=e.length-1;p>=0;p--)o=i(e[p]).data("update"),d=a.find('[data-update="'+o+'"]'),d.length<1?n&&(0===a.find(".ticker-spacer:first-child").length&&a.find(".ticker-spacer").length>0?a.children("li.ticker-spacer").before(e[p]):(h=i(e[p]),p===e.length-1&&h.addClass("last"),a.find("last").after(h),a.find("last").removeClass("last"))):a.find('[data-update="'+o+'"]').replaceWith(e[p]);a.children("li.webticker-init, li.ticker-spacer").removeClass("old"),r&&a.children("li").remove(".old"),f=0,f=t(a),a.width(f+200),a.find("li.webticker-init").length<1&&(c.startEmpty=!1),a.html(e),a.children("li").css("white-space","nowrap"),a.children("li").css("float",c.direction),a.children("li").css("padding","0 7px"),a.children("li").css("line-height",c.height),l(a,!0)}else{a.children("li").addClass("old");for(var u=0;u<e.length;u++)o=i(e[u]).data("update"),d=a.find('[data-update="'+o+'"]'),d.length<1?n&&(0===a.find(".ticker-spacer:first-child").length&&a.find(".ticker-spacer").length>0?a.children("li.ticker-spacer").before(e[u]):(h=i(e[u]),u===e.length-1&&h.addClass("last"),a.find(".old.last").after(h),a.find(".old.last").removeClass("last"))):a.find('[data-update="'+o+'"]').replaceWith(e[u]);a.children("li.webticker-init, li.ticker-spacer").removeClass("old"),a.children("li").css("white-space","nowrap"),a.children("li").css("float",c.direction),a.children("li").css("padding","0 7px"),a.children("li").css("line-height",c.height),r&&a.children("li").remove(".old"),f=0,f=t(a),a.width(f+200)}}a.webTicker("cont")}};i.fn.webTicker=function(t){return d[t]?d[t].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof t&&t?void i.error("Method "+t+" does not exist on jQuery.webTicker"):d.init.apply(this,arguments)}}(jQuery);

function marksoldoutsizes(){
    $("#select-data > option").each(function() {
    var product = $(".ProductForm").attr("id");
    product = product.replace("product_form_","");
    var condition = '';
    var size = '';
    if($(this).attr("data-product-id") == product){
      if($(this).attr("data-stock") != 'instock'){
        var soldoutsize = $(this).attr("data-size");
        $('input[value="'+soldoutsize+'"]').parent().addClass("soldout");
      }
    }
  });
}

$( document ).ready(function() {

  marksoldoutsizes();

  // THIS IS ALSO CONTROLLED IN THEME.JS "_updateAddToCartButton"
  $( '#main' ).on("click",".SizeSwatch",function (event) {
    var product = $(".ProductForm").attr("id");
    product = product.replace("product_form_","");
    var condition = '';
    var size = '';
    /*
    if($(this).html() == "Very Good" || $(this).html() == "Like New"){
      var condition = $(this).html();
    } else {
      var size = $(this).html();
    }
    if(size == ''){
      size = $('input[name=option-0]:checked', '.ProductForm').val()
    } else {
      condition = $('input[name=option-1]:checked', '.ProductForm').val()
    } 
    */
    setTimeout(function() {
      var size = $('input[name=option-0]:checked', '.ProductForm').val();
      //var condition = $('input[name=option-1]:checked', '.ProductForm').val();
      //if(size && condition){   
      //if(condition){ 
        $("#select-data > option").each(function() {


          if(size){
            if($(this).attr("data-size") == size){
              if($(this).attr("data-stock") != 'instock'){
                var soldoutcolor = $(this).attr("data-color");
                $('input[value="'+soldoutcolor+'"]').parent().parent().addClass("soldout");
              } else {
                var notsoldoutcolor = $(this).attr("data-color");
                $('input[value="'+notsoldoutcolor+'"]').parent().parent().removeClass("soldout");
              }
            }
          }
          if($(this).attr("data-product-id") == product){
            if($(this).attr("data-stock") != 'instock'){
              var soldoutsize = $(this).attr("data-size");
              $('input[value="'+soldoutsize+'"]').parent().addClass("soldout");
            } else {
              var notsoldoutsize = $(this).attr("data-size");
              $('input[value="'+notsoldoutsize+'"]').parent().removeClass("soldout");
            }
          }

        });
  
      //} else {
  
      //}
    }, 50);

  });

  
  $(document).on('click','.ProductItem-addtocart-button',function(e){
    e.preventDefault();
    var ID = $(this).attr("data-variant");
    console.log(ID);
    var button = this;
    button.innerHTML = "Adding...";
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: $(this).attr("data-variant")
      },
      dataType: 'json',
      success: function (data){
        document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
        setTimeout(function () {
          button.innerHTML = "Add to Cart";
        }, 2500);
      },
      error: function () {
        button.innerHTML = "Out of Stock";
        /*
        setTimeout(function () {
          button.innerHTML = "Not available";
        }, 2500);
        alert("This product is no longer available.")
        */
      }

    });
  });

  $(document).on('click','.drawer-cart-addtocart',function(e){
    e.preventDefault();
    var ID = $(this).attr("data-variant");
    console.log(ID);
    var button = this;
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: $(this).attr("data-variant")
      },
      dataType: 'json',
      success: function (data){
        document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
        /*
        setTimeout(function () {
          button.innerHTML = "Add to Cart";
        }, 2500);
        */
      },
      error: function () {
        /*
        button.innerHTML = "Out of Stock";
        */
      }

    });
  });


  // SCROLL TO TOP OF PAGE
  $("a[href='#top']").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });

  // PRESS HOVER
  $(".TestimonialNav__Item").hover(function() {
    $(this).trigger("click");
  });
  
// EXPAND
  function checkVisible( elm, eval ) {
      eval = eval || "visible";
      var vpH = $(window).height(), // Viewport Height
          st = $(window).scrollTop(), // Scroll Top
          y = $(elm).offset().top,
          elementHeight = $(elm).height();

      if (eval == "visible") return ((y < (vpH + st)) && (y > (st - elementHeight)));
      if (eval == "above") return ((y < (vpH + st)));
  }   

  var scrollPos = 0;
  window.addEventListener('scroll', function(){
    //if ((document.body.getBoundingClientRect()).top > scrollPos){
    //} else {
    
      $('.video').each( function(){        
          if (checkVisible($(this))) {
            if($(this).hasClass("firstplayed")){
            } else {
              $(this)[0].currentTime = 0;
              $(this)[0].play();
              $(this).addClass("firstplayed");
            }
          }
      }); 
    
      $('.js-scrollFade').each( function(){        
          var id = $(this).attr("id");
          var tester = document.getElementById(id);
          if (checkVisible($(this))) {
            $(this).addClass("is-in-view");
          }
      }); 
    
      $('.js-scrollFade-all').each( function(){        
          var id = $(this).attr("id");
          var tester = document.getElementById(id);
          if (checkVisible($(this))) {
            $(this).addClass("is-in-view");
          }
      }); 

    
      // SCROLL DOWN
      $('.expand').each( function(){ 
        /*
        var speed = 0.01555;
        */
        var speed = 0.01;

        var width = $( window ).width();
        /*
        if(width > 1500){
          speed = speed;
        } else if(width < 641){
          speed = speed/2;
        }
        */
        var id = $(this).attr("id");
        var tester = document.getElementById(id);
        if (checkVisible($(this))) {
          var matrixRegex = /matrix\((-?\d*\.?\d+),\s*0,\s*0,\s*(-?\d*\.?\d+),\s*0,\s*0\)/,
          matches = $(this).css('-webkit-transform').match(matrixRegex);
          var transform = parseFloat(matches[1]);
          if(transform < 1){
            transform = transform + speed;
            transform = "matrix("+transform+", 0, 0, "+transform+", 0, 0)";
            var transform =  $(this).css("transform", transform);
          }
        }
      }); 
    //}
    scrollPos = (document.body.getBoundingClientRect()).top;
  });

 
  
  // MOBILE/DESKTOP IMAGE RESIZE
  $(window).resize(function() {          
      resizeImg();
  });  
  function resizeImg() { 
    
      if ($(window).width() > 640) {
        $( ".resize" ).each(function() {
          $( this ).attr("src", $( this ).attr("data-src-desktop"));          
          var image = "url("+$( this ).attr("data-src-desktop")+")";
        });            
      } else {
        $( ".resize" ).each(function() {
          $( this ).attr("src", $( this ).attr("data-src-mobile"));          
          var image = "url("+$( this ).attr("data-src-mobile")+")";
        });      
      } 
  }

  $( window ).on( "load", function() {
      resizeImg();
  });
  
  // HOMEPAGE TICKER
  $("#webTicker").webTicker({
      height:'70px',
      duplicate:true, 
      startEmpty:false,
      hoverpause:false 
  });
  

  
});




// 2019 PRESTIGE THEME FIX
(function() {
    let touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      let moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
})();

/* PRELOVED */
$( document ).ready(function() {
  $( '#main' ).on("click",".size-display",function (event) {
    if($(this).hasClass("expanded")){
      $(this).next().slideUp();
      $(this).removeClass("expanded");
    } else {
      $(this).next().slideDown();
      $(this).addClass("expanded");
    }
  });
  $( '#main' ).on("click",".SizeSwatch.option-Size",function (event) {
    var value = $(this).html();
    $(".size-display-text").html(value);
    $(".SwatchListContainer.options-Size").slideUp();
    $(".size-display").removeClass("expanded");
    $(".size-display").addClass("selected");
    sessionStorage.setItem("size", value);
  });
  $( '#main' ).on("click",".SizeSwatch.option-Condition",function (event) {
    var value = $(this).html();
    var text = '';
    sessionStorage.setItem("condition", value);
    if(value == 'Excellent'){
      var text = 'Good as new.';
    } else if (value == 'Like New') {
      var text = 'Minor discoloration on outsoles.';
    } else if (value == 'Very Good') {
      var text = 'Very minimal wear and tear.';
    } else {
      var text = '';
    }
    $(".condition-description").html(text);
  });
  
  // IS SIZE WAS SELECTED THEN AUTO-SELECT IT
  function selectSize(){
    var sessionsize = sessionStorage.getItem("size");
    if(sessionsize){
      $( '.ProductForm .SizeSwatch.option-Size' ).each(function() {
        if($(this).html() == sessionsize){
          $(this).trigger("click");
        }
      });
    }
  }
  selectSize();
  
  // IS CONDITION WAS SELECTED THEN AUTO-SELECT IT
  function selectCondition(){
    var sessioncondition = sessionStorage.getItem("condition");
    if(sessioncondition){
      $( '.ProductForm .SizeSwatch.option-Condition' ).each(function() {
        if($(this).html() == sessioncondition){
          $(this).trigger("click");
        }
      });
    } else {
      $( '.ProductForm .SizeSwatch.option-Condition' ).each(function() {
        if($(this).html() == 'Like New'){
          $(this).trigger("click");
        }
      });
    }
  }
  selectCondition();

  $( '#main' ).on("click",".shoe-color-group-buttons a",function (event) {
    event.preventDefault();
    var colorgroup = $(this).attr('data-color-group');
    sessionStorage.setItem("colorgroup", colorgroup);
    $('.shoe-color-group-buttons a').each(function() {
      if($(this).attr('data-color-group') == colorgroup){
        $(this).addClass("active");
      } else{
        $(this).removeClass("active");
      }
    });
    $('.color-swatches').each(function() {
      if($(this).attr('data-color-group') == colorgroup){
        $(this).addClass("active");
        $(this).flickity('resize');
      } else {
        $(this).removeClass("active");
      }
    });

  });
  
  // IS COLORGROUP WAS SELECTED THEN AUTO-SELECT IT
  function selectColorGroup(){
    var colorgroup = sessionStorage.getItem("colorgroup");
    if(colorgroup){
      $('.shoe-color-group-buttons a').each(function() {
        if($(this).attr('data-color-group') == colorgroup){
          $(this).trigger("click");
        }
      });
    }
  }
  selectColorGroup();
  


  function swatchSlider(){

    $(".color-swatches").each(function() {
      $(this).flickity({
          contain: true,
          cellAlign: 'left',
          groupCells: true,
          prevNextButtons: true,
          pageDots: false
      });
    });  
  } 
  swatchSlider();



/* AJAX COLOR SWATCHES */

  function changeColor(href){

        var n = href.indexOf('?');
        href = href.substring(0, n != -1 ? n : href.length);

    	// MOVE/HIDE BACK IN STOCK FORM
    	$("#back-in-stock").insertAfter("#product-section").hide();
        $("#mobile-product-description-content").show();

    	$("#modal-buttons-container").remove();
    	$(".Product__Tabs").remove();
    
    	var load = href+" #product-info-content > *";

        // RELOAD FORM
       	$("#product-info-content").load(load, function(){  

          // UPDATE JS
          var src = "//samplesale.goclove.com/cdn/shop/t/24/assets/theme.js?v=99860481209312690281765210279";
          $('script[src="' + src + '"]').remove();
          $('<script>').attr('src', src).appendTo('head');

          // UNDO-MOVE/HIDE BACK IN STOCK FORM
          $("#back-in-stock").insertAfter("#product-info .ProductForm");
          $("#back-in-stock").show();
          
          // UPDATE AFFIRM
          affirm.ui.refresh();

          // GET AND UPDATE PAGE TITLE AND URL?
          var currenttitle = document.title;
          myArray = currenttitle.split(" ");
          
          var title = $(".colorway-title").text().trim();
          var sex = $(".sex-selected").text().trim();
          title = sex + " " + title + " Shoes | Clove";          
          window.history.pushState('Product', title, href);
          document.title = title;

          selectSize();
          selectColorGroup();
          selectCondition();
          swatchSlider();
          marksoldoutsizes();

          
       	});

        // RELOAD IMAGES
        if ($(window).width() > 1007) {
          $("#product-images").fadeTo("fast",0);
          var load = href+" #product-images > *";
          $("#product-images").load(load, function(){
            $("#product-images").fadeTo("fast",1);
          });
          var load = href+" #product-images-mobile > *";
          $("#product-images-mobile").load(load, function(){
            var $carousel = $('.Product__Slideshow').flickity({
              prevNextButtons: true,
              watchCSS: true,
              pageDots: true,
              adaptiveHeight: true  
            });
            $carousel.resize();
          });
        } else {
          $("#product-images-mobile").fadeTo("fast",0);
          var load = href+" #product-images-mobile > *";
          $("#product-images-mobile").load(load, function(){
            var $carousel = $('.Product__Slideshow').flickity({
              prevNextButtons: true,
              watchCSS: true,
              pageDots: true,
              adaptiveHeight: true  
            });
            $carousel.resize();
            $("#product-images-mobile").fadeTo("fast",1);            
          }); 
          var load = href+" #product-images > *";
          $("#product-images").load(load, function(){
          });
        }

        // RELOAD MOBILE HEADER
    	var load = href+" #product-mobile-header > *";
       	$("#product-mobile-header").load(load, function(){
        });
    
        /*
        // RELOAD STICKY
    	var load = href+" #product-sticky > *";
       	$("#product-sticky").load(load, function(){});

        // RELOAD REVIEWS
    	var load = href+" #product-mobile-header [data-oke-reviews-product-listing-rating] > *";
    	$("#product-mobile-header [data-oke-reviews-product-listing-rating]").empty();
       	$("#product-mobile-header [data-oke-reviews-product-listing-rating]").load(load, function(){});

    	var load = href+" .okeReviews-mobile-widget [data-oke-reviews-widget] > *";
    	$(".okeReviews-mobile-widget [data-oke-reviews-widget]").empty();
       	$(".okeReviews-mobile-widget [data-oke-reviews-widget]").load(load, function(){});

    	var load = href+" .okeReviews-desktop-widget [data-oke-reviews-widget] > *";
    	$(".okeReviews-desktop-widget [data-oke-reviews-widget]").empty();
       	$(".okeReviews-desktop-widget [data-oke-reviews-widget]").load(load, function(){});

        // RELOAD BELOW THE FOLD
    	var load = href+" #product-styles-container > *";
       	$("#product-styles-container").load(load, function(){
            $(window).trigger('resize');
        });
        */
      

  
  }
  
  $('#shopify-section-product-template').on('click', '.ProductItem__ColorSwatchItem a', function(e) {
    e.preventDefault()
    var href = $(this).attr("href");
    changeColor(href);
  });

});
